import React from 'react'
import cx from 'classnames'

const ConditionalRender = ({ children, condition, className }) => {
  if (condition) {
    return (
      <div className={cx(className)}>
        {children}
      </div>
    )
  }

  return null
}

export default ConditionalRender
